export const styles = {
  Navbar: {
    zIndex: 10,
    width: '100%',
    backgroundColor: 'black',
    height: '110px',
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 780px)': {
      backgroundColor: 'black',
      height: '80px',
    },
  },
  Navbar_Mobile: {
    position: 'absolute',
    zIndex: 200,
    width: 'calc(100% - 20px)',
    backgroundColor: 'black',
    borderRadius: '54px',
    left: '50%',
    transform: 'translateX(-50%)',
    top: '10px',
  },

  HeaderContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '20px 133px',
    zIndex: 800,
    position: 'relative',
    width: 'fill-available',
    '@media (max-width: 1200px)': {
      padding: '20px 30px',
    },
    '@media (max-width: 780px)': {
      padding: '20px 16px',
    },
  },
  MobileHeaderContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: '80px',
    alignItems: 'center',
    zIndex: 800,
    position: 'relative',
    width: '100%', // Changed from fill-available for better cross-browser support
  },

  ImageContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    lineHeight: 0,
    img: {
      maxWidth: '100px',
      maxHeight: '80px',
    },
    '@media (max-width: 780px)': {
      img: {
        maxWidth: '50px',
        maxHeight: '50px',
      },
    },
  },
  NavLinksContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'right',
    alignItems: 'center',
    // width: 'calc(100% - 300px)',
    width: '100%',
    margin: '0 40px',
    gap: '40px',
    '@media (max-width: 780px)': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      backdropFilter: 'blur(5px)',
      zIndex: 0,
      position: 'absolute',
      flexDirection: 'column',
      left: '0',
      right: '0',
      top: '-150vh',
      height: '100vh',
      transition: 'top 0.5s ease-in-out',
    },
  },
  NavLinksContainer_Mobile: {
    display: 'flex',
    justifyContent: 'center',
    gap: '30px',
    backdropFilter: 'blur(5px)',
    zIndex: 0,
    position: 'absolute',
    flexDirection: 'column',
    left: '0',
    right: '0',
    top: '-150vh',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    width: '100%',
    alignItems: 'flex-start',
    transition: 'top 0.5s ease-in-out',
  },
  Logo: {
    '@media (max-width: 780px)': {
      height: 'auto',
    },
  },
  Logo_Mobile: {
    height: 'auto',
  },
  NavlinkWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },

  NavLink: {
    display: 'flex',
    alignItems: 'center',
    color: '#009b3a',
    fontSize: '14px',
    textDecoration: 'none',
    fontWeight: '700',
    borderRadius: '4px',
  },
  NavButtons: {
    color: '#009b3a',
    fontSize: '14px',
    padding: '8px',
    borderColor: '#fff',
  },
  NavButtonContainer: {
    maxWidth: '300px',
    '@media (max-width: 780px)': {
      position: 'absolute',
      bottom: 0,
      marginBottom: '30px',
    },
  },
  NavButtonContainer_Mobile: {
    // position: 'absolute',
    // bottom: 0,
    marginTop: '20px',
  },
  MenuButtonContainer: {
    display: 'none',

    '@media (max-width: 780px)': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      zIndex: 100,
      WebkitTapHighlightColor: 'transparent',
    },
  },
  MenuButtonContainer_Mobile: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    zIndex: 250,
    WebkitTapHighlightColor: 'transparent',
  },
  Icon: {
    color: '#fff',
    fontSize: '40px',
    WebkitTapHighlightColor: 'transparent',
  },
  MenuActive: {
    '@media (max-width: 780px)': {
      backdropFilter: 'blur(5px)',
      zIndex: 0,
      position: 'absolute',
      flexDirection: 'column',
      left: '0',
      right: '0',
      top: '0',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      height: '100vh',
      transition: 'top 0.5s ease-in-out',
    },
  },
  MenuActive_Mobile: {
    backdropFilter: 'blur(5px)',
    zIndex: 0,
    position: 'absolute',
    flexDirection: 'column',
    left: '0',
    right: '0',
    top: '0',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    height: '100vh',
    transition: 'top 0.5s ease-in-out',
  },
};
